/* eslint-disable linebreak-style */
import {
  TOI_PLUS_ENABLING_CONDITIONS_API_WEB,
  TOI_PLUS_ENABLING_CONDITIONS_API_MWEB,
  PRC_FOR_SUBSCRIBED,
  // PRC_FOR_SUBSCRIBED,
} from 'constants/index';
import { isPrimeUser } from 'utils/common';
import { getPrcCookieValue, timeDifference } from 'utils/primeUtil';
import reducerRegistry from '../reducerRegistry';
import makeRequest from '../../utils/makeRequest';

const reducerName = 'toiplusconfig';
const createActionName = name => `toi/${reducerName}/${name}`;

export const RECEIVE_TOI_PLUS_CONFIG = createActionName(
  'RECEIVE_TOI_PLUS_CONFIG',
);

export const RECEIVE_UPDATED_TOI_PLUS_CONFIG = createActionName(
  'RECEIVE_UPDATED_TOI_PLUS_CONFIG',
);
export const HANDLE_DATA_ERROR = createActionName('HANDLE_DATA_ERROR');

function handleError(error) {
  //console.log('handle error');
  return {
    type: HANDLE_DATA_ERROR,
    error,
  };
}

function receiveToiPlusConfigData(
  data,
  isPrime,
  currentContinent,
  currentRegion,
  currentCountry,
) {
  return {
    type: RECEIVE_TOI_PLUS_CONFIG,
    payload: {
      data,
      isPrime,
      currentContinent,
      currentRegion,
      currentCountry,
    },
  };
}

function receiveUpdatedToiPlusConfigData(isPrime, renewNudgeCloseDuration) {
  return {
    type: RECEIVE_UPDATED_TOI_PLUS_CONFIG,
    payload: { isPrime, renewNudgeCloseDuration },
  };
}

export function getToiPlusConfig(isWapView) {
  const url = isWapView
    ? TOI_PLUS_ENABLING_CONDITIONS_API_MWEB
    : TOI_PLUS_ENABLING_CONDITIONS_API_WEB;
  return makeRequest.get(url, {}, 'skipfeedengine');
}

export function loadToiPlusConfig(
  isPrime,
  isWapView,
  currentContinent,
  currentRegion,
  currentCountry,
) {
  return dispatch => {
    getToiPlusConfig(isWapView)
      .then(data => {
        if (data && data.data) {
          dispatch(
            receiveToiPlusConfigData(
              data.data,
              isPrime,
              currentContinent,
              currentRegion,
              currentCountry,
            ),
          );
        }
      })
      .catch(error => dispatch(handleError(error)));
  };
}

export function loadUpdatedToiPlusConfig(isPrime, renewNudgeCloseDuration) {
  return dispatch => {
    dispatch(receiveUpdatedToiPlusConfigData(isPrime, renewNudgeCloseDuration));
  };
}

export default function reducer(state = {}, action) {
  switch (action.type) {
    case RECEIVE_TOI_PLUS_CONFIG: {
      const {
        data,
        isPrime,
        currentContinent,
        currentRegion,
        currentCountry,
      } = action.payload;

      // const isToiPlusEnabledInRegion =
      //   data.toiPlusEnabledCountries.indexOf(currentCountry) > -1;
      const isToiPlusEnabledInCountry = !(
        data.toiPlusDisabledCountries.indexOf(currentCountry) > -1
      );
      let showToiPlusEntryPoints = false;
      let showToiPlusNudges = false;
      let showToiPlusCongratspopup = true;
      let showToiPlusPlanPage = true;
      let hideToiPlusBlockerScreen = true;

      const isToiPlusUser = isPrime || isPrimeUser();
      const { legalDisabledCountries = {}, toiPlusAllowReadOnly = {} } = data;
      const isLegalDisabledRegion =
        legalDisabledCountries &&
        legalDisabledCountries.region.indexOf(currentRegion) > -1;
      const isLegalDisabledContinent =
        legalDisabledCountries &&
        legalDisabledCountries.continent.indexOf(currentContinent) > -1;
      const isToiPlusAllowReadOnly =
        toiPlusAllowReadOnly &&
        (toiPlusAllowReadOnly.countries?.indexOf(currentCountry) > -1 ||
          toiPlusAllowReadOnly.region?.indexOf(currentRegion) > -1 ||
          toiPlusAllowReadOnly.continent?.indexOf(currentContinent) > -1);
      if (
        (isLegalDisabledRegion ||
          isLegalDisabledContinent ||
          !isToiPlusEnabledInCountry) &&
        !isToiPlusAllowReadOnly
      ) {
        showToiPlusCongratspopup = false;
        showToiPlusPlanPage = false;
        hideToiPlusBlockerScreen = false;
      }

      if (isToiPlusEnabledInCountry && !isToiPlusAllowReadOnly) {
        if (!isLegalDisabledRegion && !isLegalDisabledContinent) {
          showToiPlusEntryPoints = true;
          if (!isToiPlusUser) {
            showToiPlusNudges = true;
          }
        }
      } else if (
        isToiPlusUser &&
        !isLegalDisabledRegion &&
        !isLegalDisabledContinent &&
        !isToiPlusAllowReadOnly
      ) {
        showToiPlusEntryPoints = true;
      }
      if (isToiPlusAllowReadOnly) {
        if (isToiPlusUser) {
          hideToiPlusBlockerScreen = true;
        }
        showToiPlusPlanPage = false;
        showToiPlusEntryPoints = true;
      }
      return {
        ...state,
        showToiPlusEntryPoints,
        showToiPlusPlanPage,
        showToiPlusCongratspopup,
        showToiPlusNudges,
        isToiPlusAllowReadOnly,
        hideToiPlusBlockerScreen,
        isToiPlusEnabledInCountry,
        isLegalDisabledRegion,
        isLegalDisabledContinent,
      };
    }
    case RECEIVE_UPDATED_TOI_PLUS_CONFIG: {
      const { isPrime, renewNudgeCloseDuration } = action.payload;
      let inGracePeriod = false;
      let preExpiry = false;
      let showRenewNudge = true;
      const isToiPlusUser = isPrime || isPrimeUser();
      if (typeof window !== 'undefined') {
        inGracePeriod =
          sessionStorage.getItem('inGracePeriod') === true ||
          sessionStorage.getItem('inGracePeriod') === 'true';
        preExpiry =
          sessionStorage.getItem('displayRenewNudge') === true ||
          sessionStorage.getItem('displayRenewNudge') === 'true';
        const closedDateInStorage = localStorage.getItem('renewNudgeCloseTime');
        const closedDate = closedDateInStorage
          ? new Date(closedDateInStorage)
          : '';
        if (
          closedDate &&
          !timeDifference(closedDate, new Date(), renewNudgeCloseDuration)
        ) {
          showRenewNudge = false;
        }
      }
      let { showToiPlusNudges } = state;
      const {
        isToiPlusEnabledInCountry,
        isToiPlusAllowReadOnly,
        isLegalDisabledRegion,
        isLegalDisabledContinent,
      } = state;

      if (isToiPlusEnabledInCountry && !isToiPlusAllowReadOnly) {
        if (!isLegalDisabledRegion && !isLegalDisabledContinent) {
          const prcValue = getPrcCookieValue();
          if (
            isToiPlusUser &&
            inGracePeriod &&
            prcValue === PRC_FOR_SUBSCRIBED
          ) {
            showToiPlusNudges = true;
          } else if (
            isToiPlusUser &&
            preExpiry &&
            showRenewNudge &&
            prcValue === PRC_FOR_SUBSCRIBED
          ) {
            showToiPlusNudges = true;
          }
        }
      }
      return {
        ...state,
        showToiPlusNudges,
      };
    }
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
